/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostEmployeesCheckMutationRequest, PostEmployeesCheckMutationResponse, PostEmployeesCheck400 } from "../entities/PostEmployeesCheck";

function getPostEmployeesCheckUrl() {
  const res = { method: 'POST', url: `/employees/check` as const }  
  return res
}

/**
 * @description Проверка номера сотрудника в Drivee
 * @summary Проверка номера сотрудника в Drivee
 * {@link /employees/check}
 */
export async function postEmployeesCheck(data: PostEmployeesCheckMutationRequest, config: Partial<RequestConfig<PostEmployeesCheckMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostEmployeesCheckMutationResponse, ResponseErrorConfig<PostEmployeesCheck400>, PostEmployeesCheckMutationRequest>({ method : "POST", url : getPostEmployeesCheckUrl().url.toString(), data : requestData, ... requestConfig })  
  return res.data
}